import { CheckoutPage } from "./CheckoutPage";
import { CheckoutWrapper } from "./CheckoutWrapper";
import type { CheckoutProps } from "./types/CheckoutProps";

// TODO: Since all information is now stored within the checkout session data,
// refactor this component and its children to utilize the session data instead of the props.
export const Checkout = (props: CheckoutProps) => {
  const { shouldUseWrapper } = props;

  const Wrapper =
    (shouldUseWrapper ?? true) ? CheckoutWrapper : CheckoutWrapper.Preview;

  return (
    <Wrapper {...props}>
      <CheckoutPage />
    </Wrapper>
  );
};
